import { useSelector } from "react-redux";

import { getRegion } from "seneca-common/features/user/state";
import { useRedirectOnCondition } from "seneca-common/utils/hooks/routing";

export default function useRedirectIfNonGB(link: string) {
  const region = useSelector(getRegion);
  const isNonGB = region !== "GB";

  useRedirectOnCondition(isNonGB, link);
}
